module.exports = __webpack_public_path__ + "img/Iconly-Light-Outline-Send.b4a2c0e5.svg";